import { Sentry } from 'app/utils/sentry';
import { searchActions } from 'app/views/layout/views/search/search.actions';
import { history } from 'store';
import { createSearchUrl } from './utils/url/createSearchUrl';
export const searchMiddleware = () => (store) => {
    const persistParamsToURL = (newParams) => {
        var _a;
        const state = store.getState();
        const params = Object.assign(Object.assign({}, state.search.params), newParams);
        const currQueryString = history.location.search.substring(1); // Remove the leading '?'
        const nextQueryString = (_a = createSearchUrl('conversations', params).split('?')[1]) !== null && _a !== void 0 ? _a : '';
        // Only update the URL if the query string has changed.
        if (nextQueryString !== currQueryString) {
            history.push(`${history.location.pathname}?${nextQueryString}`);
        }
    };
    return (next) => (action) => {
        try {
            switch (action.type) {
                case searchActions.params.update.type: {
                    const { payload } = action;
                    persistParamsToURL(payload);
                    break;
                }
                case searchActions.savedSearch.apply.type: {
                    const { payload } = action;
                    persistParamsToURL(payload.params);
                    break;
                }
            }
        }
        catch (exception) {
            Sentry.captureException(new Error('Search: middleware exception caught'));
        }
        return next(action);
    };
};
